import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=8fb2096e&scoped=true&"
import script from "./Sponsors.vue?vue&type=script&lang=js&"
export * from "./Sponsors.vue?vue&type=script&lang=js&"
import style0 from "./Sponsors.vue?vue&type=style&index=0&id=8fb2096e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb2096e",
  null
  
)

export default component.exports